import './polifill'
import './config'
import './const'
import './directive'
import './filter'

import Vue from 'vue'
import router from './router'
import store from './store'

import Plugins from './plugins'

import App from './components/App.vue'

Vue.config.productionTip = false

const init = async () => {
  try {
    // 초기 로딩값으로 필요한 사항
    await store.dispatch('system/init')
  } finally {
    global.$vm = new Vue({
      router,
      store,
      vuetify: Plugins.vuetify,
      render: (h) => h(App),
    }).$mount('#app')
    global.$vm.$gtm.trackEvent({ event: 'init-app' })
  }
}
init()
